import { Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import TimePointsGroup from '../TimePointsGroup'
import AllTimepointsViewerSelector, { ModalityOption, ViewableSubmission } from './AllTimepointsViewerSelector'

export type TimePointManagerProps = {
  selectedTimePointSubmission: string
  timePoints: Array<{
    name: string
    id: string
    maximumAllowedTimepoints: number
    children: Array<{ name: string; id: string }>
  }>
  viewableSubmissions?: ViewableSubmission[]
  modalityOptions?: ModalityOption[]
  onOpenAllInViewer?: (selectedTimepointSubmissionIds: string[], selectedModalities: string[] | null) => void
  submittedOnly?: boolean
  submittedOnlyLocked?: boolean
  onSubmittedOnlyChange?: (submittedOnly: boolean) => void
}

export default function TimePointManager({
  selectedTimePointSubmission,
  timePoints,
  viewableSubmissions = [],
  modalityOptions = [],
  onOpenAllInViewer,
  submittedOnly = false,
  submittedOnlyLocked = false,
  onSubmittedOnlyChange,
}: TimePointManagerProps) {
  return (
    <Box px={3}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.75} gap={1}>
        <Typography variant="h6">All timepoints</Typography>
        {onOpenAllInViewer && viewableSubmissions.length > 0 && (
          <AllTimepointsViewerSelector
            submissions={viewableSubmissions}
            modalities={modalityOptions}
            onOpenViewer={onOpenAllInViewer}
            disabled={viewableSubmissions.every((s) => s.isViewable === false)}
          />
        )}
      </Box>
      {onSubmittedOnlyChange ? (
        <FormControlLabel
          sx={{ ml: 0, mb: 1 }}
          control={
            <Checkbox
              checked={submittedOnlyLocked || submittedOnly}
              disabled={submittedOnlyLocked}
              onChange={(_event, checked) => onSubmittedOnlyChange(checked)}
            />
          }
          label="Submitted visits only"
        />
      ) : null}
      <Stack gap={1} py={3} data-testid="time-points-group">
        {timePoints.map((item) => (
          <TimePointsGroup
            key={item.id}
            id={item.id}
            name={item.name}
            children={item.children}
            selectedTimePointSubmission={selectedTimePointSubmission}
            maximumAllowedTimepoints={item.maximumAllowedTimepoints}
          />
        ))}
      </Stack>
    </Box>
  )
}
